import React from 'react';
import NavBar from './components/navBar/navBar';

function App() {

  return (
    <NavBar />
  );
}

export default App;